import { Combobox } from "@/components/ui/combobox";
import { useListBaseTraders, type BaseTrader } from "@/lib/api/trader";

/** One trader, picked like ManageCustomers' trader. */
export function TraderSelect({
  value,
  onChange,
  disabled,
}: {
  value: string;
  onChange: (traderId: string) => void;
  disabled: boolean;
}) {
  const tradersResult = useListBaseTraders();
  const traders: BaseTrader[] = tradersResult.data?.success ? tradersResult.data.data : [];
  const traderOptions = traders.map((trader) => ({ value: trader.id, label: trader.name }));
  const failedToLoad = tradersResult.isError || tradersResult.data?.success === false;

  return (
    <div className="space-y-1">
      <Combobox
        isModal
        dwimOnChange
        virtualizeList
        popoverClassName='md:min-w-[300px] lg:min-w-[400px] xl:min-w-[500px]'
        className="w-full"
        placeholder={tradersResult.isLoading ? "Loading traders…" : "—"}
        options={traderOptions}
        value={value}
        onValueChange={onChange}
        disabled={disabled}
      />
      {failedToLoad && <p className="text-xs text-red-600">Couldn't load the traders.</p>}
    </div>
  );
}
